// extracted by mini-css-extract-plugin
module.exports = {"feed":"feed_feed__1LgkF","feedWrapper":"feed_feedWrapper__2gFqF","noPost":"feed_noPost__kMbqd"};